import { createReducer } from 'redux-starter-kit';
import {
  cancelEditNotification, editNotification,
  fetchAddNotification, fetchNotificationPageData, fetchUpdateNotification,
} from './NotificationUiActions';
import { selectRequest } from '../../domain/requests/RequestReducer';


/**
 * A selector for finding the current edit state.
 */
export const selectEditState = state => state.via.ui.notifications.editState;

/**
 * A selector that returns the state of the 'FETCH_NOTIFICATIONS_PAGE_DATA' action.
 */
export const selectNotificationsPageDataRequest = (state) => {
  const requestId = state.via.ui.notifications.requestNotificationsPageDataId;
  if (!requestId) return null;
  return selectRequest(state, requestId);
};

/**
 * A selector for the current 'FETCH_CREATE_NOTIFICATION' request.
 */
export const selectSubmitNotificationsRequest = (state) => {
  const requestId = state.via.ui.notifications.editState.requestSubmitNotification;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

const initialEditingState = {
  isEditing: false,
  notificationId: null,
  requestSubmitNotification: null,
  validationMessages: ({
    title: '',
    messages: [],
    visible: false,
  }),
};

const notificationInitialState = {
  editState: initialEditingState,
  requestNotificationsPageDataId: null,
};

/**
 * A reducer for handling the UI state changes for the Inspection reason Configuration screen.
 */
const notificationUIReducer = createReducer(notificationInitialState, {
  // The user has started editing the inspection reason.
  [editNotification]: (state, action) => ({
    ...state,
    editState: {
      ...state.editState,
      isEditing: true,
      notificationId: action.payload,
    },
  }),

  // The user has stopped editing
  [cancelEditNotification]: state => ({
    ...state,
    editState: {
      ...initialEditingState,
    },
  }),

  // A new create request
  [fetchAddNotification]: (state, action) => ({
    ...state,
    editState: {
      ...state.editState,
      requestSubmitNotification: action.payload,
    },
  }),

  // A new update request
  [fetchUpdateNotification]: (state, action) => ({
    ...state,
    editState: {
      ...state.editState,
      requestSubmitNotificationId: action.payload,
    },
  }),

  // A new request for the main data
  [fetchNotificationPageData]: (state, action) => ({
    ...state,
    requestNotificationsPageDataId: action.payload,
  }),

});

export default notificationUIReducer;
